import React from "react";
import updatesApp from "@insightfulscience/contentful/Apps/Updates";
import { WithLocale } from "@insightfulscience/i18";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import SiteLayout from "@src/SiteLayout";
import { withErrorHandling } from "@src/AppError";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import { contentfulProps } from "@src/config";
import updates from "../../locales/updates-page";

const updatesLayout = ({ children }) => {
	return (
		<SiteLayout>
			<PageMeta>
				<PageMeta.OGP
					image="/images/snapgene/meta/preview-snapgene-dotmatics.png"
					imageSecureUrl="/images/snapgene/meta/preview-snapgene-dotmatics.png"
					isImageBaseUrl
				/>
				<PageMeta.Twitter
					image="/images/snapgene/meta/preview-snapgene-dotmatics.png"
					isImageBaseUrl
				/>
			</PageMeta>
			{children}
		</SiteLayout>
	);
};

export default pipe(
	updatesApp({
		Layout: updatesLayout,
		contentfulProps,
		pageProps: {
			brandCode: "sg",
			siteDomain: "https://www.snapgene.com",
		},
	}),
	WithLocale({ resources: updates }),
	withErrorHandling,
);
